module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "PT"
  }, [_vm._v("GAIA")]), _vm._v(" "), _c('p', {
    staticClass: "PIT"
  }, [_vm._v("Sometimes I wonder what I would say if I were ever asked out on a date.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("You’d think that since it’s never happened to me, I might have had some time in the past seventeen years to formulate the perfect response. You’d think that with all the movies I’ve seen, I would have at least picked up some cheesy line. Some doe-eyed, swooning acceptance.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("But I pretty much stay away from romantic comedies. There’s no relationship advice to be had from a Neil LaBute film.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Besides, you can’t formulate the perfect response for a situation you can’t remotely imagine.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("I figure that if it ever does happen (not probable), I’ll end up saying something along the lines of “uh” or slight variations thereof.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("“Uh . . . uh,” if the guy’s a freak.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("“Uh . . . huh,” if the guy’s a nonfreak.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("I wonder what Heather said to Sam when he first asked her out. Probably something disgustingly perfect. Something right out of a movie. Something like, “I was wondering when you’d ask.” Or maybe Heather asked Sam out. And he said something like, “It would be my honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Okay. Stomach now reacting badly. Must think about something else.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("What did Heather say when "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Ed")]), _vm._v(" asked her out?")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Okay. Stomach now severely cramping.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("So what happens after the “Uh . . . huh”?")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Awkward pauses, I assume. Idiot small talk, sweaty palms (his), dry mouth (also his), bad food. (I imagine dates don’t happen at places where they have good food—like Gray’s Papaya or Dojo’s.)")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("And I won’t even get into what happens after the most likely difficult digestion. What does the nonfreak expect at that point? Hand holding? Kissing? Groping? Heavy groping? Sex?")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Stomach no longer wishes to be a component of body.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Must stop here.")]), _vm._v(" "), _c('p', {
    staticClass: "PTX"
  }, [_vm._v("Luckily I won’t ever have to deal with any of this. Because no nonfreak will ever ask me out. And no freak will ever get more than the initial grunt.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02663fc6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part2.vue
// module id = 78
// module chunks = 0